import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { saveConsent, readConsent } from "@/lib/analytics";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const c = readConsent();
    if (!c) setVisible(true);
  }, []);

  const acceptAll = () => {
    saveConsent({ analytics: true });
    setVisible(false);
  };

  const rejectOptional = () => {
    saveConsent({ analytics: false });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Informativa sui cookie"
      className="fixed bottom-3 left-3 right-3 sm:left-6 sm:right-6 z-50 mx-auto max-w-3xl rounded-xl sm:rounded-2xl border border-[#E8E6E1] bg-white/95 backdrop-blur-md shadow-[0_12px_40px_-12px_rgba(26,54,45,0.25)] px-4 py-3 sm:px-6 sm:py-5"
    >
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex-1 font-ui text-xs sm:text-sm text-[#1A362D] leading-snug sm:leading-relaxed">
          {expanded ? (
            <>
              <p className="font-display text-sm sm:text-base font-semibold mb-1">Cookie e privacy</p>
              <p className="text-[#5C6B64]">
                Per manina è una community indipendente. Usiamo <strong>cookie tecnici essenziali</strong> per
                farti restare loggata e mantenere la sessione, e — con il tuo consenso — <strong>cookie analitici
                anonimi</strong> (Google Analytics con IP mascherato) per capire quali contenuti aiutano di più
                i genitori e <strong>cookie di profilazione pubblicitaria</strong> (Google AdSense ed eventuali
                vendor IAB TCF 2.2) per sostenere il progetto con pubblicità rilevante. Puoi gestire o revocare
                i tuoi consensi in ogni momento.{" "}
                <Link
                  to="/info/privacy"
                  data-testid="cookie-banner-privacy-link"
                  className="underline text-[#C05C45] hover:text-[#1A362D]"
                >
                  Privacy Policy
                </Link>
                {" · "}
                <Link
                  to="/info/cookie"
                  data-testid="cookie-banner-cookie-link"
                  className="underline text-[#C05C45] hover:text-[#1A362D]"
                >
                  Cookie Policy
                </Link>
                .
              </p>
            </>
          ) : (
            <>
              <p className="text-[#1A362D]">
                Aiutaci a capire cosa serve davvero ai genitori: accetta i cookie analitici anonimi e
                ci aiuterai a migliorare il sito.{" "}
                <button
                  type="button"
                  onClick={() => setExpanded(true)}
                  data-testid="cookie-banner-details-btn"
                  className="underline text-[#C05C45] hover:text-[#1A362D]"
                >
                  Dettagli
                </button>
              </p>
              <p className="mt-1 text-[10px] sm:text-xs text-[#8A9691] font-ui">
                Cookie tecnici sempre attivi · Analytics e pubblicità solo col tuo consenso
              </p>
            </>
          )}
        </div>
        <div className="flex flex-row gap-2 shrink-0">
          <button
            type="button"
            onClick={rejectOptional}
            data-testid="cookie-banner-reject-btn"
            className="whitespace-nowrap px-3 py-1.5 sm:px-4 sm:py-2 rounded-md border border-[#E8E6E1] bg-white text-[#1A362D] font-ui text-xs sm:text-sm hover:bg-[#F2EFEB] transition-colors"
          >
            Solo essenziali
          </button>
          <button
            type="button"
            onClick={acceptAll}
            data-testid="cookie-banner-accept-btn"
            className="btn-primary whitespace-nowrap text-xs sm:text-sm px-3 py-1.5 sm:px-4 sm:py-2"
          >
            Accetta tutti
          </button>
        </div>
      </div>
    </div>
  );
}
